import type { SelectProps } from '@mui/material/Select'

/** Dense dropdown options for compact selects. */
export const compactSelectMenuProps: SelectProps['MenuProps'] = {
    PaperProps: {
        sx: {
            '& .MuiMenuItem-root': {
                minHeight: 32,
                py: 0.5,
                fontSize: '0.8125rem',
            },
        },
    },
}
